
import React from 'react';
import { ShoppingCart, Store as StoreIcon, Settings } from 'lucide-react';
import { useApp } from '../AppContext';

interface NavbarProps {
  onOpenCart?: () => void;
}

const Navbar: React.FC<NavbarProps> = ({ onOpenCart }) => {
  const { cart, currentStore, user } = useApp();
  const cartCount = cart.reduce((acc, item) => acc + item.quantity, 0);

  const handleLogoClick = () => {
    if (currentStore) {
      window.location.hash = `#/${currentStore.slug}`;
    } else {
      window.location.hash = '#/admin';
    }
  };

  return (
    <nav className="sticky top-0 z-50 bg-white border-b border-gray-200 px-4 py-3">
      <div className="max-width-7xl mx-auto flex items-center justify-between">
        <div 
          className="flex items-center gap-2 cursor-pointer group" 
          onClick={handleLogoClick}
        >
          <div className="bg-indigo-600 p-1.5 rounded-lg text-white group-hover:bg-indigo-700 transition-colors">
            <StoreIcon size={20} />
          </div>
          <h1 className="text-xl font-bold tracking-tight text-gray-900 line-clamp-1">
            {currentStore ? currentStore.name : 'Venda Local'}
          </h1>
        </div>
        
        <div className="flex items-center gap-2">
          {/* Só mostra o botão de Admin se o usuário estiver logado (Dono da loja) */}
          {user && (
            <button 
              onClick={() => window.location.hash = '#/admin'}
              className="text-gray-400 hover:text-indigo-600 transition-colors p-2 rounded-full hover:bg-gray-100"
              title="Voltar ao Painel"
            >
              <Settings size={22} />
            </button>
          )}
          
          <button 
            onClick={onOpenCart}
            className="relative p-2 text-gray-700 hover:text-indigo-600 transition-colors rounded-full hover:bg-gray-100"
          >
            <ShoppingCart size={24} />
            {cartCount > 0 && (
              <span className="absolute top-0 right-0 bg-red-500 text-white text-[10px] font-bold px-1.5 py-0.5 rounded-full border-2 border-white">
                {cartCount}
              </span>
            )}
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
